export class SpreadsheetCellData {
    css: string;

    constructor(public cell: string, public value: any, public dimensionNumber?: number) {
    }
}